import React, { createContext, useContext, useEffect, useState } from 'react';

const SapphireContext = createContext(null);

export const SapphireProvider = ({ children }) => {
  const [sapphires, setSapphires] = useState(() => {
    const saved = localStorage.getItem('nro_sapphires');
    return saved ? parseInt(saved, 10) : 0;
  });

  useEffect(() => {
    localStorage.setItem('nro_sapphires', String(sapphires));
  }, [sapphires]);

  const add = (amount) => setSapphires((s) => s + amount);
  const reset = () => setSapphires(0);

  return (
    <SapphireContext.Provider value={{ sapphires, setSapphires, add, reset }}>
      {children}
    </SapphireContext.Provider>
  );
};

export const useSapphires = () => {
  const ctx = useContext(SapphireContext);
  if (!ctx) throw new Error('useSapphires must be used inside SapphireProvider');
  return ctx;
};
